<template>
  <div class="contenedor">
    <p>Your projects</p>
    <hr />
    <div class="contenedor2">
      <div class="targetas" v-for="(item, index) in projects" :key="index">
        <CardProyect :info="item" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CardProyect from "../components/CardProject";

export default {
  name: "Proyects",
  data: () => ({
  }),
  components: { CardProyect,  },
  methods: {
    startTour() {
      this.$tours["ProjetsSteps"].start();
    },
  },
  computed: {
    ...mapState(["projects"]),
  }
};
</script>
<style lang="css" scoped>
hr {
  background: var(--eighth-color);
  height: 2px;
  border: none;
}
.contenedor2 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.contenedor p {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  margin-bottom: 2px;
}
</style>